import type { GetCourseDrafts200PageableSort } from './getCourseDrafts200PageableSort';

/**
 * 페이징 정보
 */
export type GetCourseDrafts200Pageable = {
  /** 오프셋 */
  offset?: number;
  /** 페이징 여부 */
  paged?: boolean;
  /** 페이지 번호 */
  pageNumber?: number;
  /** 페이지 크기 */
  pageSize?: number;
  /** 정렬 정보 */
  sort?: GetCourseDrafts200PageableSort;
  /** 페이징 안 함 여부 */
  unpaged?: boolean;
};
